// frontend/modules/sms/views/SmsManagementView.tsx
import React from 'react';
import { Typography, Tabs, Card } from 'antd';
import SmsForm from '../components/SmsForm';
import { useTheme } from '@/components/common/ThemeProvider';

const { Title } = Typography;
const { TabPane } = Tabs;

const SmsManagementView: React.FC = () => {
    const { dark } = useTheme();

    return (
        <div className="space-y-6">
            <Card className={dark ? 'bg-gray-800 text-white' : ''}>
                <Title level={4} className={dark ? 'text-white' : ''}>
                    SMS Management
                </Title>
                <Typography.Paragraph className={dark ? 'text-gray-300' : ''}>
                    Send SMS messages to your customers and track your SMS balance.
                </Typography.Paragraph>
            </Card>

            <Tabs defaultActiveKey="send" className={dark ? 'text-white' : ''}>
                <TabPane tab="Send SMS" key="send">
                    <SmsForm />
                </TabPane>

                <TabPane tab="SMS History" key="history">
                    <Card className={dark ? 'bg-gray-800 text-white' : ''}>
                        <Title level={5} className={dark ? 'text-white' : ''}>
                            SMS History
                        </Title>
                        <Typography.Paragraph className={dark ? 'text-gray-300' : ''}>
                            SMS history functionality will be implemented in a future update.
                        </Typography.Paragraph>
                    </Card>
                </TabPane>
            </Tabs>
        </div>
    );
};

export default SmsManagementView;